import { checkIcon, h } from '../utils'
import { fieldError } from './error'
import { uniqueId } from './id'

interface CheckboxFieldOptions {
  label: string
  name: string
  hidden?: boolean
}

export function checkboxField(options: CheckboxFieldOptions) {
  const id = uniqueId()
  const label = h(
    'label',
    { class: 'vbzc-checkbox-label', for: id },
    {
      children: [
        h('input', { class: 'vbzc-checkbox-input', type: 'checkbox', id, name: options.name }),
        h('span', { class: 'vbzc-checkbox-control' }, { children: [checkIcon()] }),
        h('div', { class: 'vbzc-prose vbzc-prose-sm' }, { html: options.label }),
      ],
    },
  )

  // Error
  const { el: error } = fieldError()

  // Field
  const field = h(
    'div',
    { 'class': 'vbzc-field' + (options.hidden ? ' vbzc-field-hidden' : ''), 'data-name': options.name },
    { children: [label, error] },
  ) as HTMLDivElement

  return { field, label, error }
}
